import { render, staticRenderFns } from "./JVxeDragSortCell.vue?vue&type=template&id=44d9e9bc"
import script from "./JVxeDragSortCell.vue?vue&type=script&lang=js"
export * from "./JVxeDragSortCell.vue?vue&type=script&lang=js"
import style0 from "./JVxeDragSortCell.vue?vue&type=style&index=0&id=44d9e9bc&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports